import type {HostMap} from '../../../types'

export const PRODUCTION = {
  account: 'delivery-frontend-account-yango.delivery.yandex.net',
  auth: 'delivery-frontend-auth-yango.delivery.yandex.net',
  route: 'ddelivery-frontend-route-yango.delivery.yandex.net',
  tariffs: 'delivery-frontend-tariffs-lb-yango.delivery.yandex.net',
  yaAuthProxy: {
    default: 'ya-authproxy.yango.com',
    authorized: 'ya-authproxy.yango.com',
  },
  s3: {
    default: 'static.yango.tech',
  },
  avatars: 'avatars.mds.yango.tech',
  cspReport: 'csp.yango.tech',
  passport: {
    default: 'passport.yango.com',
    id: 'id.yango.com',
    api: 'api.passport.yango.com',
  },
  rum: 'clck.yango.tech',
  metrica: {default: 'mc.yango.com'},
  forms: {default: 'forms.yango.com'},
  maps: {
    default: 'js.api.maps.yango.com',
  },
} as const satisfies HostMap
